import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Get ring details for a PO (from h_po_rings_detail, aggregated by ring_unique_name)
 * @param {number|string} poId - PO record id (h_po_authorized_records.id)
 * @returns {Promise<{ success: boolean, data?: array }>}
 */
export const getPoRingsDetail = async (poId) => {
  try {
    const response = await apiClient.get(`/vendorInvoiceManagement/invoice/rings-detail/${poId}`);
    const data = response.data?.response ?? response.data;
    const list = Array.isArray(data) ? data : [];
    return { success: true, data: list };
  } catch (error) {
    handleApiError(error);
    return { success: false, data: [] };
  }
};
